import React, { useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import logo from '../assets/img/logo.png';
const QRCodeWithGradientAndLogo = ({
    value = "",
    size = 256,

    logoSizeRatio = 0.2, // tamaño del logo relativo al QR
}) => {
    const gradientId = "qr-gradient";
    const logoSize = size * logoSizeRatio;
    const logoPosition = (size - logoSize) / 2;

    useEffect(() => {
        // Si no existe el gradiente en el DOM, lo inyectamos

    }, []);

    return (

        <div
            style={{
                width: size,
                height: size,
                borderRadius: 20,
                padding: 12,
                display: "inline-block",
                position: "relative",
            }}
        >
            <QRCodeSVG
                value={value}
                size={size - 24} // ajustado por padding
                bgColor="transparent"
                fgColor={`url(#${gradientId})`}
                level="H"
                includeMargin={false}
            />


            {/* Logo centrado */}
            <img
                src={logo}
                alt="Logo"
                style={{
                    position: "absolute",
                    top: logoPosition,
                    left: logoPosition,
                    width: logoSize,
                    height: logoSize,
                    borderRadius: logoSize * 0.3,
                    background: "white",
                    padding: 4,
                    boxShadow: "0 0 6px rgba(0,0,0,0.15)",
                    pointerEvents: "none",
                }}
            />
        </div>
    );
};

export default QRCodeWithGradientAndLogo;